<!-- Client Registration form -->
<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid">

        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Client Registration</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-12 col-md-12 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary  mb-1">
                                    <form [formGroup]="cRegisterForm">
                                        <div class="row">
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Name</mat-label>
                                                        <input matInput formControlName="name" minlength="3" title="Name at least has 3 characters !">
                                                        <mat-error *ngIf="cRegisterForm.controls.name.errors?.required">This field is required !</mat-error>
                                                        <mat-error *ngIf="cRegisterForm.controls.name?.value">Name at least has 3 characters !</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Email</mat-label>
                                                        <input matInput formControlName="email">
                                                        <mat-error *ngIf="cRegisterForm.controls.email.errors?.required">This field is required ! </mat-error>
                                                        <mat-error *ngIf="cRegisterForm.controls.email.errors?.email">Require valid email format ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Number</mat-label>
                                                        <input matInput formControlName="number" type="tel" pmPhoneFormat>
                                                        <mat-error *ngIf="cRegisterForm.controls.number.errors?.required">This field is required ! </mat-error>
                                                        <mat-error *ngIf="cRegisterForm.controls.number.errors?.pattern">Invalid format! Use 555-123-4567</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Phone-Type</mat-label>
                                                        <mat-select formControlName="phoneType" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let phone of phoneType" [value]="phone.value">{{phone.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="cRegisterForm.controls.phoneType.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Address</mat-label>
                                                        <input matInput formControlName="firstLine" placeholder="First Line" >
                                                        <mat-error *ngIf="cRegisterForm.controls.firstLine.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>City</mat-label>
                                                        <input matInput formControlName="city"  >
                                                        <mat-error *ngIf="cRegisterForm.controls.city.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-6" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>State</mat-label>
                                                        <mat-select formControlName="state" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of stateList" [value]="type.value">{{type.label}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="cRegisterForm.controls.state.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Zip</mat-label>
                                                        <input matInput formControlName="zip" pmZipCode >
                                                        <mat-error *ngIf="cRegisterForm.controls.zip.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Authorized Signatory</mat-label>
                                                        <input matInput formControlName="authorizedSignatory">
                                                        <mat-error *ngIf="cRegisterForm.controls.authorizedSignatory.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Designation</mat-label>
                                                        <input matInput formControlName="designation">
                                                        <mat-error *ngIf="cRegisterForm.controls.designation.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Software & System</mat-label>
                                                        <input matInput formControlName="softwareAndSystem">
                                                        <mat-error *ngIf="cRegisterForm.controls.softwareAndSystem.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Integration Requirements</mat-label>
                                                        <input matInput formControlName="integrationRequirements">
                                                        <mat-error *ngIf="cRegisterForm.controls.integrationRequirements.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <!-- Deactivate Date (only while editing) -->
                                            <div *ngIf="clientId" class="col-xl-5 col-md-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Deactivate Date</mat-label>
                                                        <input
                                                            matInput
                                                            [matDatepicker]="deactivateDatePicker"
                                                            formControlName="deactivationDate">
                                                        <mat-datepicker-toggle
                                                            matSuffix
                                                            [for]="deactivateDatePicker">
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #deactivateDatePicker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            
                                            <!-- Additional Information -->
                                            <div [ngClass]="clientId ? 'col-xl-6 col-md-6' : 'col-xl-12 col-md-12'">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Additional Information</mat-label>
                                                        <textarea matInput formControlName="additionalInformation" rows="4"></textarea>
                                                    </mat-form-field>
                                                </div>
                                            </div>


                                            <!-- Status -->
                                            <div *ngIf="clientId" class="col-xl-1 col-md-12 mt-3 pt-2">
                                                <div [ngClass]="status ? 'active' : 'inactive'">
                                                    <span class="text-primary">Status :</span>
                                                    {{ status ? 'Active' : 'Inactive' }}

                                                    <label class="switch">
                                                        <input
                                                            type="checkbox"
                                                            class="success"
                                                            [checked]="status"
                                                            (click)="changeStatus(status)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            routerLink="/client"
                                            class="btn btn-secondary float-end waves-effect waves-light">
                                            Cancel
                                        </button>

                                        <button
                                            *ngIf="!clientId"
                                            type="button"
                                            class="btn btn-outline-light btn-lg px-5 float-right"
                                            mat-raised-button
                                            color="primary"
                                            (click)="onRegister()">
                                            Register
                                        </button>

                                        <button
                                            *ngIf="clientId"
                                            type="button"
                                            class="btn btn-outline-light btn-lg px-5 float-right"
                                            mat-raised-button
                                            color="primary"
                                            (click)="onRegister()">
                                            Update
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

